import merge from 'deepmerge';

/**
 * @param {...object} objects - Objects to recursively merge
 */
export default function multimerge(...objects) {
  return merge.all(objects);
}
